import { Channel } from '@/types/channel.types';
import { Get } from '../helpers';

const FetchChannels = async (): Promise<Channel[]> => {
  return Get({ path: '/v3/admin/auth/channels' });
};

export default FetchChannels;
